import { useState, useEffect } from 'react';
import { Navigate } from 'react-router';
import { auth } from '../../lib/firebase';
import { onAuthStateChanged, User } from 'firebase/auth';
import { Loader2 } from 'lucide-react';

export default function AdminGuard({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#faf9fe]">
        <Loader2 className="w-10 h-10 animate-spin text-[#24477e]" />
      </div>
    );
  }

  if (!user) {
    // If not authenticated via Firebase, redirect to the login page
    return <Navigate to="/admin-login" replace />;
  }

  return <>{children}</>;
}
